import moment, { Moment } from 'moment';
import { defaultDateTimeFormat } from '../constants';

// Shift constraints are stored as times of day with no date, so an end that reads
// "earlier" than the start (e.g. 21:00 to 03:00) means the shift runs past midnight
// onto the next day. Without the extra day the window is negative and consumers such
// as the Gantt timeline collapse the shift bar to its minimum width.
const getShiftEndMoment = (
  startDate: string,
  startTime: string | undefined | null,
  endTime: string | undefined | null,
): Moment => {
  const end = moment(`${startDate} ${endTime}`, defaultDateTimeFormat);
  // A missing time already parses to midnight on startDate, which would look like a
  // midnight crossing, so only compare when both ends of the shift are known.
  if (!startTime || !endTime) return end;

  const start = moment(`${startDate} ${startTime}`, defaultDateTimeFormat);

  return end.isBefore(start) ? end.add(1, 'day') : end;
};

export default getShiftEndMoment;
